<template>
		<b-container fluid class="d-flex flex-column h-100">
			<b-row align-v="center" class="mt-1">
				<b-col align-v="center">
					<div class="d-flex justify-content-center">
							<!-- "Nom du rapport" -->
						<div class="p-2 pr-3">{{ $t('ReportName') }} : </div>
						<b-form-select v-model="selectId" value-field="Id" text-field="Label" plain
							class="w-50 rounded" :class="'border-' + Variant">
							<b-form-select-option v-for="report in reportList" :key="report.Id"
								:value="report.Id">
								{{ report.Name }}
							</b-form-select-option>
						</b-form-select>
					</div>
				</b-col>
			</b-row>
			<b-row>
				<b-col cols="11">
					<b-button-group class="btn-color-all">
						<b-button @click="changeComponent('DesignerParameter')" :disabled="component == 'DesignerParameter'" :variant="Variant">Paramètre</b-button>
						<b-button @click="changeComponent('DesignerDescription')" :disabled="component == 'DesignerDescription'" :variant="Variant">Description</b-button>
						<b-button @click="changeComponent('DesignerEditor')" :disabled="component == 'DesignerEditor'" :variant="Variant">Editors</b-button>
					</b-button-group>
				</b-col>
				<b-col cols="1">
					<b-button v-b-tooltip.hover :title="'Energistrer'" :variant="Variant" class="border-0 btn-circle m-1 position-absolute" style="right: 25px" @click="saveChildComponent()"> 
						<i class="bi bi-floppy"></i>
					</b-button>
				</b-col>
			</b-row>
			<b-row class="p-0 pt-2 flex-grow-1 w-100 h-100 mh-100">
				<b-col class="h-100 w-100 pl-0 pr-0" >
					<keep-alive>
						<component :is="component" :ref="component" :Report="reports?.find(u => u.ReportId == this.selectId)"/>
					</keep-alive>
				</b-col>
			</b-row>
		</b-container>
</template>

<script lang="ts">
	import { Component, Vue, Watch, Prop } from "vue-property-decorator";
	import { API_URL } from "@/App.settings";
	import locales from "../Workbench/RightPane/FeatureContainer/Reporting/locales/Exploitation.json";
	import axios from 'axios';
	import Dictionary from '@/types/Dictionary';
	import DesignerParameter from "./ReportDesigner/Parameters/DesignerParameter.vue";
	import DesignerDescription from "./ReportDesigner/Description/DesignerDescription.vue";
	import DesignerEditor from "./ReportDesigner/Editors/DesignerEditor.vue";
	import ReportList from "../Workbench/RightPane/FeatureContainer/Reporting/ReportList";
	import Report from "../Workbench/RightPane/FeatureContainer/Reporting/Report";

	@Component({
		i18n: {messages: locales},
		components: {
			DesignerParameter,
			DesignerDescription,
			DesignerEditor
		}
	})
	export default class ReportDesigner extends Vue{
		@Prop({default: () => "secondary"})
		public Variant!: string;

		private component: string = "";
	
		private changeComponent(componentName: string) {
			this.component = componentName;
		}

		public reportList: ReportList[] = []; 
		public reports: Report[] = [];
		public selectId: string = "";

        private async getReportList()
        {
            // LoadingReportList -> Chargement de la liste des rapports
            this.reportList = [];

            const args: Dictionary<any> = {};
            args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";

            await axios.post<ReportList[]>(API_URL + "ReportExploitation/GetAllReportList", args).then((response) => {
                this.reportList = response.data;
                if(this.reportList){
					this.selectId = this.reportList[0].Id.toString();
				}
                else {
                    this.selectId = "";
                }
            })
        }

        @Watch('selectId')
        private async getReport() {
            if (this.selectId != "") {
                if (this.reports === undefined || this.reports != undefined && this.reports.find(u => u.ReportId === this.selectId) === undefined) {
                    const args: Dictionary<any> = {};
                    args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
                    args["ReportId"] = this.selectId;

                    try{
                        await axios.post<Report>(API_URL + "ReportExploitation/GetReport", args).then((response) => {
                            let report: Report = new Report().CreateReport(response.data);
                            // let report: Report = Report.CreateReport(response.data);
                            this.reports.push(report);
                    })
                    } catch (e){
                        console.log("Error : ", e)
                    } 
                }
            }
        }

		@Watch('component')
		private onDisplayDescriptionChange(){
		}

		private saveChildComponent(){
			// Précise le type de mon composant Ref et précise qu'il à une methode Save
			let activeComponent = this.$refs[this.component] as Vue & { save: () => void };;

			// Save la modification selon le composant en cours (DesignerParameter/DesignerDescription/DesignerEditors)
			if(activeComponent && typeof activeComponent.save == 'function')	
				activeComponent.save();
		}
	
		mounted() {
			// console.clear();
			this.getReportList();
			this.component = "DesignerParameter";
		}
	}
</script>

<style scoped>
.btn:focus {
  outline: none;
  box-shadow: none;
}
</style>